import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EdiDocumentView } from '../../../models/edi-viewer';
import { EdiService } from '../../../services/edi/edi.service';
import { EdiViewerCompatibilityService } from '../../../services/edi/edi-viewer-compatibility.service';
import { EdiViewRegenerationRequest } from '../edi-view-regeneration-dialog/edi-view-regeneration-dialog.component';

@Component({
  selector: 'lib-edi-viewer-page',
  templateUrl: './edi-viewer-page.component.html',
  styleUrls: ['./edi-viewer-page.component.scss'],
  standalone: false
})
export class EdiViewerPageComponent implements OnInit {
  selectedFile?: File;
  useAi = true;
  loading = false;
  error?: string;
  view?: EdiDocumentView;
  compatibilityWarning?: string;
  messageId?: string;
  messageType?: string;
  regenerationDialogOpen = false;

  constructor(
    private ediService: EdiService,
    private compatibilityService: EdiViewerCompatibilityService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.compatibilityService.getCompatibility().subscribe(result => (this.compatibilityWarning = result.message));
    this.route.queryParamMap.subscribe(params => {
      this.messageId = params.get('messageId') || undefined;
      this.messageType = params.get('messageType') || undefined;
      if (this.messageId && this.messageType) this.view = undefined;
    });
  }

  selectFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files?.[0];
    this.error = undefined;
  }

  render(forceRegenerate = false, regeneration?: EdiViewRegenerationRequest): void {
    if (!this.selectedFile) return;
    this.loading = true;
    this.error = undefined;
    this.ediService
      .renderDocument(
        this.selectedFile,
        this.useAi,
        forceRegenerate,
        regeneration?.instruction,
        regeneration?.persistInstruction
      )
      .subscribe({
        next: view => {
          this.view = view;
          this.loading = false;
        },
        error: error => {
          this.loading = false;
          this.error = error?.error?.detail || error?.error?.message || 'The document could not be rendered.';
        }
      });
  }

  confirmRegeneration(request: EdiViewRegenerationRequest): void {
    this.regenerationDialogOpen = false;
    this.render(true, request);
  }

  openAnotherDocument(): void {
    this.regenerationDialogOpen = false;
    this.messageId = undefined;
    this.messageType = undefined;
    this.view = undefined;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {}
    });
  }
}
